import React, { useEffect, useRef } from 'react';
import { Box, CircularProgress, Grid, Typography } from '@mui/material';
import CanvasJSReact from '../ui/canvasjs/canvasjs.react';
import { useLocation } from 'react-router-dom';
import { getTransactionHistoryDivisionKPIs, getTransactionHistoryKPIs } from '../../store/actions/transactionHistory';
import { useDispatch, useSelector } from 'react-redux';
import { getDateInfo } from '../../utils/dateInfo';
import Datagrid from '../ui/Datagrid';
import { gridClasses } from '@mui/x-data-grid';
import columns from './table_config';
import { renderCell } from '../ui/Datagrid/table_config';
import { REDUX_ACTIONS } from '../../shared/config/constants';

const CanvasJSChart = CanvasJSReact.CanvasJSChart;

const chartDefaults = {
  exportEnabled: true,
  animationEnabled: true,
  theme: 'light2',
};

const TransactionHistoryKPI = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const searchParams = new URLSearchParams(location.search);
  const startDate = searchParams.get('startDate');
  const endDate = searchParams.get('endDate');
  const { transactionHistoryKPIs, transactionHistoryKPIsLoading, transactionHistoryDivisionKPIsLoading, transactionHistoryDivisionKPIs } = useSelector((state) => state.transactionHistory);
  const chartRef = useRef();
  const pageTitle = `Sales Orders: ${getDateInfo(new Date(startDate), '/').formated} - ${getDateInfo(new Date(endDate), '/').formated}`;

  useEffect(() => {
    dispatch({
      type: REDUX_ACTIONS.MENU_SET_TITLE,
      payload: pageTitle,
    });
    dispatch(getTransactionHistoryKPIs(startDate, endDate));
    dispatch(getTransactionHistoryDivisionKPIs(startDate, endDate));
  }, []);

  return (
    <Grid display={'flex'} flexDirection={'column'}>
      {transactionHistoryKPIsLoading || transactionHistoryDivisionKPIsLoading
        ? (
          <Grid container justifyContent={'center'} alignItems={'center'} sx={{ height: '400px' }}>
            <CircularProgress />
          </Grid>
          )
        : (
          <>
          {/* Bar chart - transaction history KPIs */}
            {transactionHistoryKPIs.length
              ? (
              <>
                <Box sx={{ flex: 1 }}>
                  <CanvasJSChart
                  ref={chartRef}
                  options={{
                    ...chartDefaults,
                    height: 300,
                    axisX: {
                      title: 'Email',
                      reversed: true,
                    },
                    axisY: {
                      title: 'Total Order Count',
                      includeZero: true,
                    },
                    data: [{
                      type: 'bar',
                      dataPoints: transactionHistoryKPIs
                    }]
                  }} />
                </Box>
              </>
                )
              : (
              <Typography variant='h6' sx={{ textAlign: 'center' }}>
                No data
              </Typography>
                )}

            {/* Pie chart - transaction history division KPIs */}
            {transactionHistoryDivisionKPIs.length
              ? (
              <>
                <Box sx={{ flex: 1, marginTop: 1 }}>
                  <CanvasJSChart
                  options={{
                    ...chartDefaults,
                    height: 300,
                    data: [{
                      type: 'pie',
                      startAngle: 75,
                      toolTipContent: '<b>{division}</b>: {y}',
                      legendText: '{label}',
                      indexLabelFontSize: 16,
                      indexLabel: '{division} - #percent%',
                      dataPoints: transactionHistoryDivisionKPIs
                    }]
                  }} />
                </Box>
              </>
                )
              : (
              <Typography variant='h6' sx={{ textAlign: 'center' }}>
                No data
              </Typography>
                )}
            <Grid item xs={12}>
              <Datagrid
                data={transactionHistoryKPIs}
                getRowId={(row) => row._id}
                columns={columns(renderCell)}
                loading={transactionHistoryKPIsLoading}
                autoHeight={false}
                pageSize={10}
                height={'40vh'}
                getRowHeight={() => 'auto'}
                sx={{
                  '.MuiDataGrid-columnHeaderTitle': {
                    fontWeight: 'bold !important',
                  },
                  [`& .${gridClasses.cell}`]: {
                    py: 1,
                  },
                }}
                onRowClick={({ row }) => {
                  chartRef?.current?.chart?.toolTip?.showAtX(Number(row.x));
                }}
                toolbar={{
                  options: {
                    columns: true,
                    filters: true,
                    export: {
                      enabled: true
                    },
                  },
                }}
              />
            </Grid>
          </>
          )}
    </Grid>
  );
};

export default TransactionHistoryKPI;
